(function() {
  function scrollGallery(galleryRow, direction) {
    const containerWidth = galleryRow.parentNode.clientWidth;
    const swatchWidth = galleryRow.querySelector("img").clientWidth;
    const arrowWidth = 32;
    const scrollAmount = Math.floor(containerWidth / swatchWidth) * swatchWidth - arrowWidth;

    if (direction === 'left') {
      galleryRow.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else if (direction === 'right') {
      galleryRow.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    // Delay the checkScroll call until after the scroll animation is likely to have completed
    setTimeout(() => checkScroll(galleryRow.parentNode), 250);
  }

  function checkScroll(galleryContainer) {
    const galleryRow = galleryContainer.querySelector('.card__swatches');
    if (galleryRow.innerHTML.trim() === '') return;

    const leftArrow = galleryContainer.querySelector('.left-arrow');
    const rightArrow = galleryContainer.querySelector('.right-arrow');
    const maxScrollLeft = galleryRow.scrollWidth - galleryRow.clientWidth;


    leftArrow.style.display = Math.round(galleryRow.scrollLeft) > 0 ? 'flex' : 'none';
    rightArrow.style.display = Math.round(galleryRow.scrollLeft) < maxScrollLeft ? 'flex' : 'none';
    
  }

  function enableDragScroll(element) {
    let isDown = false;
    let startX;
    let scrollLeft;
    let isDragging = false;

    element.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - element.offsetLeft;
      scrollLeft = element.scrollLeft;
      isDragging = false; // reset dragging flag on mouse down
      element.classList.add('active');
    });

    element.addEventListener('mouseleave', () => {
      isDown = false;
      element.classList.remove('active');
    });

    element.addEventListener('mouseup', (e) => {
      isDown = false;
      element.classList.remove('active');
      if (isDragging) {
        e.preventDefault(); // prevent click if it was a drag
      }
    });

    element.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - element.offsetLeft;
      const walk = x - startX;
      element.scrollLeft = scrollLeft - walk;

      if (Math.abs(x - startX) > 10) {
        isDragging = true;
      }
    });

    element.querySelectorAll('a').forEach(anchor => {
      anchor.addEventListener('click', (e) => {
        if (isDragging) {
          e.preventDefault();
        }
      });
    });
  }

  function initializeGallery() {
    document.querySelectorAll('.product-card-wrapper').forEach(galleryContainer => {
      const galleryRow = galleryContainer.querySelector('.card__swatches');

      // Initialize drag to scroll
      enableDragScroll(galleryRow);

      // Initialize checkScroll for each gallery
      checkScroll(galleryContainer);

      // Add scroll event listener to update arrows on manual scroll
      galleryRow.addEventListener('scroll', () => {
        checkScroll(galleryContainer);
      });

      // Add click event listeners for arrows
      const leftArrow = galleryContainer.querySelector('.left-arrow');
      const rightArrow = galleryContainer.querySelector('.right-arrow');

      leftArrow.addEventListener('click', () => scrollGallery(galleryRow, 'left'));
      rightArrow.addEventListener('click', () => scrollGallery(galleryRow, 'right'));

      // Prevent images from being dragged
      galleryRow.querySelectorAll('img').forEach(img => {
        img.addEventListener('dragstart', (e) => {
          e.preventDefault();
        });
      });
    });
  }

  initializeGallery();

  window.addEventListener('resize', () => {
    document.querySelectorAll('.product-card-wrapper').forEach(checkScroll);
  });
})();
